module.exports = __webpack_public_path__ + "europa-20-portrait_window.jpg?827f0d71c9207efc5651008ac71adda9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/europa-20-portrait_window.jpg
// module id = 299
// module chunks = 0